import { FaAward, FaLeaf, FaTruck, FaUsers } from "react-icons/fa6";

const fruitPulpData = {
  hero_section_home: {
    title: "Trust. Integrity. Excellence",
    brand: "Zesty",
    description: "Marinated chicken, Fruits and Vegetables",
    src: "videos/hero-bg.webm",
  },
  welcome_text_section: {
    title: "Welcome to Zesty Tongue",
    minisubline:
      "Crafting excellence in Fruit Pulps, Marinated meats and ready to cook delights!",
    description:
      "At Zesty Tongue, flavor meets integrity in every bite. In a short span, we've earned the trust of our customers by consistently delivering fresh, hygienically packed meat and ready-to-cook delights. Our unwavering focus on quality, backed by FSSAI and ISO-certified processes and a robust cold chain system, ensures that every product reflects our promise of taste, safety, and satisfaction.",
  },
  why_choose_us: [
    {
      icon: <FaAward style={{ fontSize: "32px" }} />,
      title: "Trusted Sourcing",
      description:
        "Ethically and locally sourced Raw material from certified farms and facilities for unmatched quality.",
    },
    {
      icon: <FaLeaf style={{ fontSize: "32px" }} />,
      title: "Freshness First",
      description:
        "Minimal processing, maximum flavor—our commitment to delivering nature's best, every time.",
    },
    {
      icon: <FaTruck style={{ fontSize: "32px" }} />,
      title: "Scalable Logistics",
      description:
        "Pan-India and international presence backed by strong cold-chain and fulfillment networks.",
    },
    {
      icon: <FaUsers style={{ fontSize: "32px" }} />,
      title: "Customer Centric",
      description:
        "We grow with our partners and customers—flexible solutions, transparent operations, and responsive service.",
    },
  ],
  description: {
    title: "Premium Marinated Chicken Collection",
    main_description:
      "Discover our range of 100% natural marinated chicken, crafted to preserve the authentic flavors and freshness of the finest ingredients.",
    segment_description:
      "Effortless meal preparation with our ready-to-use marinated chicken.",
    variety_description:
      "Available in a variety of flavors and pack sizes to suit every need.",
  },
  features: [
    {
      id: 1,
      title: "100% Natural Ingredients",
      description: "Made from fresh, high-quality fruits without additives.",
    },
    {
      id: 2,
      title: "Convenient and Ready to Use",
      description: "Save prep time with pulps that are ready out of the pack.",
    },
    {
      id: 3,
      title: "Rich in Flavor and Nutrition",
      description: "Vitamins, antioxidants, and authentic fruit taste.",
    },
    {
      id: 4,
      title: "Versatile Applications",
      description: "Great for smoothies, desserts, beverages, and more.",
    },
  ],
  overlay_card: [
    {
      id: 1,
      key: "Signature Spice Blend",
      image: "Signature_Spice_Blend.webp",
      title: "Signature Spice Blend",
      description:
        "Infused with authentic Kerala spices and bold Guntur Karam for unforgettable flavour",
    },
    {
      id: 2,
      key: "Chef-ready Convenience",
      image: "Chef-ready_Convenience.webp",
      title: "Chef-ready Convenience",
      description:
        "No prep, no mess—ready-to-cook for quick turnaround in commercial or home kitchens",
    },
    {
      id: 3,
      key: "Consistent Quality",
      image: "Consistent_Quality.webp",
      title: "Consistent Quality",
      description:
        "Each batch is marinated to perfection, ensuring uniform flavor and tenderness",
    },
    {
      id: 4,
      key: "Versatile Cooking Options",
      image: "Versatile_Cooking_Options.webp",
      title: "Versatile Cooking Options",
      description:
        "Ideal for grilling, pan-frying, roasting, or tandoor—delivers excellence every time",
    },
  ],
  our_products_section: {
    title: "Our Premium Products",
    description:
      "Discover our range of high-quality products crafted with care and expertise",
  },
  category_feature_card: [
    {
      image: "media/packchicken.webp",
      title: "Marinated Chicken",
      description:
        "Premium chicken marinated with our signature blend of natural spices, ready to cook and serve.",
      features: ["Fresh and hygienic", "Natural ingredients", "Ready to cook"],
      link: "/marinated-chicken",
    },
    {
      image: "media/pulppack.webp",
      title: "Pulp Pack",
      description:
        "Conveniently packed fruit pulp, ready to use in your favorite recipes.",
      features: ["100% natural", "No preservatives", "Easy to use"],
      link: "/fruit-pulp",
    },
    {
      image: "media/packseafood.webp",
      title: "SeaFoods",
      description:
        "Fresh and premium seafood, sourced and prepared to deliver the authentic taste of the ocean.",
      features: ["Ocean fresh", "Premium quality", "Ready to cook"],
      link: "/seafood",
    },
  ],
  zestyMark: {
    features: [
      "Premium quality ingredients",
      "Authentic flavors",
      "Rigorous quality control",
      "Sustainable practices"
    ],
    tagline: "Where flavor meets integrity"
  },


};

export default fruitPulpData;
